<template>
  <shared-news-thumbnail-component
    :data="hit"
  />
</template>

<script setup>
const props = defineProps({
  hit: Object
})
</script>
